import { NoddiDateFormats, noddiFormatDate } from 'noddi-util';
import { DateParam, withDefault } from 'use-query-params';
import { useNoddiQueryParam } from '../../../hooks/useNoddiQueryParam';

export const useDatePickerQueryParam = ({
  paramKey = 'date',
  defaultValue
}: {
  paramKey?: string;
  defaultValue?: Date;
} = {}) => {
  const [date, setDate] = useNoddiQueryParam(paramKey, withDefault(DateParam, defaultValue ?? new Date()));

  return {
    date,
    setDate,
    // we need to format the date to be used in the the api declaration
    apiDate: noddiFormatDate(date, NoddiDateFormats.API_DATE)
  };
};
